import PropTypes from "prop-types"
import MetaTags from "react-meta-tags"
import React, { useState, useEffect } from "react"
import {
  Container,
  Row,
  Col,
  Card,
  Alert,
  CardBody,
  Media,
  Button,
} from "reactstrap"

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation"

// Redux
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"

//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb"

import avatar from "../../assets/images/users/sample_user.png"
// actions
import { editProfile, resetProfileFlag } from "../../store/actions"



const UserProfile = props => {
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [otherNames, setOtherNames] = useState("");
  const [phone, setPhone] = useState("");
  const [userId, setUserId] = useState("")
  const [idx, setIdx] = useState(1);
  const [isEditing, setIsEditing] = useState(false); // For edit mode

  useEffect(() => {
    if (localStorage.getItem("authUser")) {
      const obj = JSON.parse(localStorage.getItem("authUser"));
      setFirstName(obj.first_name);
      setLastName(obj.last_name);
      setOtherNames(obj.other_name || "");
      setEmail(obj.email);
      setPhone(obj.phone || "");
      setUserId(obj.id || "");
      setIdx(obj.uid);
      setTimeout(() => {
        props.resetProfileFlag();
      }, 10000);
    }
  }, [props.success]);

  function handleValidSubmit(event, values) {
    props.editProfile({
      ...values,
      id: userId,
      token: JSON.parse(localStorage.getItem("authUser")).token
    });
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Row>
            <Col lg="12">
              {props.error && <Alert color="danger">{props.error}</Alert>}
              {props.success && <Alert color="success">{props.success}</Alert>}

              <Card>
                <CardBody>
                  <div className="d-flex">
                    <div className="ms-3">
                      <img
                        src={avatar}
                        alt=""
                        className="avatar-md rounded-circle img-thumbnail"
                      />
                    </div>
                    <div className="align-self-center flex-1">
                      <div className="text-muted">
                        <h5>{`${firstName} ${lastName}`}</h5>
                        <p className="mb-1">{email}</p>
                        <p className="mb-0">Id no: #{idx}</p>
                      </div>
                    </div>
                    <Button
                      color="primary"
                      className="ms-auto"
                      onClick={() => setIsEditing(!isEditing)}
                    >
                      {isEditing ? "Cancel" : "Edit"}
                    </Button>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <h4 className="card-title mb-4">User Details</h4>

          <Card>
            <CardBody>
              <AvForm
                className="form-horizontal"
                onValidSubmit={(e, v) => handleValidSubmit(e, v)}
              >
                <div className="mb-3">
                  <AvField
                    name="first_name"
                    label="First Name"
                    value={firstName}
                    onChange={e => setFirstName(e.target.value)}
                    className="form-control"
                    type="text"
                    required
                    disabled={!isEditing}
                  />
                </div>

                <div className="mb-3">
                  <AvField
                    name="last_name"
                    label="Last Name"
                    value={lastName}
                    onChange={e => setLastName(e.target.value)}
                    className="form-control"
                    type="text"
                    required
                    disabled={!isEditing}
                  />
                </div>

                <div className="mb-3">
                  <AvField
                    name="other_name"
                    label="Other Names"
                    value={otherNames}
                    onChange={e => setOtherNames(e.target.value)}
                    className="form-control"
                    type="text"
                    disabled={!isEditing}
                  />
                </div>

                <div className="mb-3">
                  <AvField
                    name="email"
                    label="Email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    className="form-control"
                    type="email"
                    required
                    disabled={!isEditing}
                  />
                </div>

                <div className="mb-3">
                  <AvField
                    name="phone"
                    label="Phone Number"
                    value={phone}
                    onChange={e => setPhone(e.target.value)}
                    className="form-control"
                    type="text"
                    disabled={!isEditing}
                  />
                </div>

                {isEditing && (
                  <Button color="primary" type="submit">
                    Save
                  </Button>
                )}
              </AvForm>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};



UserProfile.propTypes = {
  editProfile: PropTypes.func,
  error: PropTypes.any,
  success: PropTypes.any,
}

const mapStatetoProps = state => {
  const { error, success } = state.Profile
  return { error, success }
}

export default withRouter(
  connect(mapStatetoProps, { editProfile, resetProfileFlag })(UserProfile)
)
